<template>
<div class="chapter">
<div class="inner_page">
<p class="p-in1">This book is dedicated to Robert Zonka, 1928–1985. God love ya. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?8e218e94